export const CategoryNumToName: {[key: string]: string} = {
    "1": "game-server",
    "2": "discord-bot",
    "3": "voice-server"
}